import React from 'react';
import { ChevronRight, Home } from 'lucide-react';
import { Button } from './button';
import { cn } from '@/utils';

interface BreadcrumbItem {
  label: string;
  href?: string;
  onClick?: () => void;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  className?: string;
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ items, className }) => {
  if (items.length === 0) return null;

  return (
    <nav className={cn("flex items-center space-x-1 text-sm text-gray-500", className)} aria-label="Breadcrumb">
      <Button
        variant="ghost"
        size="sm"
        className="h-auto p-1 text-gray-500 hover:text-gray-700"
        onClick={() => window.location.href = '/dashboard'}
      >
        <Home className="h-4 w-4" />
      </Button>

      {items.map((item, index) => (
        <React.Fragment key={index}>
          <ChevronRight className="h-4 w-4 text-gray-400" />
          {item.href || item.onClick ? (
            <Button
              variant="ghost"
              size="sm"
              className="h-auto p-1 text-gray-500 hover:text-gray-700 font-normal"
              onClick={item.onClick}
              asChild={!!item.href}
            >
              {item.href ? (
                <a href={item.href}>{item.label}</a>
              ) : (
                item.label
              )}
            </Button>
          ) : (
            <span className="text-gray-900 font-medium">{item.label}</span>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default Breadcrumb;